import { useEffect } from "react";
import MUITable from "../../../Common/MUITable";
import { useDailyReportStore } from "./AttendanceSummaryReport/store/useDailyReportStore";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { DailyReportFilterForm } from "./AttendanceSummaryReport/DailyReportFilterForm";

const DailyReport = () => {
  const {
    dailyEmployeeAttendance,
    isFetchingDailyEmployeeAttendance,
    fetchDailyEmployeeAttendance,
  } = useDailyReportStore();

  useEffect(() => {
    fetchDailyEmployeeAttendance(); // Fetch report on component mount
  }, [fetchDailyEmployeeAttendance]);

  const attendanceSummaryHeaderColumns = [
    {
      label: "EMP ID",
      field: "employeeId",
    },
    {
      label: "Name",
      field: "employeeName",
    },
    {
      label: "Operation",
      field: "operationName",
    },
    {
      label: "Designation",
      field: "designationName",
    },
    {
      label: "Location",
      field: "punchInLocation",
    },
    {
      label: "Punch-In Time",
      field: "punchInTime",
    },
    {
      label: "Punch-In Location",
      field: "punchInLocation",
    },
    {
      label: "Punch-Out Time",
      field: "punchOutTime",
    },
    {
      label: "Punch-Out Location",
      field: "punchOutLocation",
    },
    {
      label: "Working Hours",
      field: "workingHours",
    },
  ];
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">Daily Report</h4>
            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">
                  <DailyReportFilterForm />
                  <MUITable
                    needSRNumber
                    columns={attendanceSummaryHeaderColumns}
                    rows={dailyEmployeeAttendance} // Pass data here
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyReport;
